module.exports = __webpack_public_path__ + "static/media/hand-middle-finger.9cd517c7.svg";